module.exports = __webpack_public_path__ + "ly.2441391f648b6704bc8b.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ly.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ly.svg
// module chunks = styles